
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { TRANSLATIONS } from './translations';

export type Language = 'fr' | 'en';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private currentLang = new BehaviorSubject<Language>('fr');
    currentLang$ = this.currentLang.asObservable();

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        // Try to load from local storage only if in browser
        if (isPlatformBrowser(this.platformId)) {
            const savedLang = localStorage.getItem('appLang') as Language;
            if (savedLang && (savedLang === 'fr' || savedLang === 'en')) {
                this.currentLang.next(savedLang);
            }
        }
    }

    setLanguage(lang: Language) {
        this.currentLang.next(lang);
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('appLang', lang);
        }
    }

    getLanguage(): Language {
        return this.currentLang.value;
    }

    translate(key: string, params: Record<string, string | number> = {}): string {
        const lang = this.currentLang.value;
        let translation = (TRANSLATIONS[lang] as any)[key] || (TRANSLATIONS['fr'] as any)[key] || key;

        Object.keys(params).forEach(param => {
            translation = translation.replace(`{${param}}`, params[param].toString());
        });

        return translation;
    }
}
